import type { JSX } from 'react';

import { useHealth } from '../api/client.ts';
import { hintClass } from '../ui/styles.ts';

/** The system's own state, at the bottom of every screen where it cannot be in the way. */
export function HealthFooter(): JSX.Element {
  const health = useHealth();

  if (health.isPending) {
    return <p className={hintClass}>Checking system status…</p>;
  }
  if (health.isError) {
    return (
      <p role="alert" className="text-sm text-danger">
        System status unavailable
      </p>
    );
  }

  const healthy = health.data.status === 'ok';

  return (
    <p className={`flex flex-wrap items-center gap-2 ${hintClass}`}>
      <span
        aria-hidden="true"
        className={`inline-block size-2 rounded-full ${healthy ? 'bg-positive' : 'bg-warning'}`}
      />
      <span>System status:</span>
      <strong data-testid="health-status">{health.data.status}</strong>
      <span>v{health.data.version}</span>
    </p>
  );
}
